import React, { Fragment, useEffect } from 'react';
import useModelSelectOptions from '../../../hooks/useModelSelectOptions';
import { makesSelectProps, modelsSelectProps, variantsSelectProps } from '../../../utils/selectOptionsProps';
import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { customSelectStyles } from '../../../utils/SelectStyles';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import InputSkeleton from '../../../components/loaders/InputSkeleton';
import { useSelector } from 'react-redux';

export default function VehiclesExtraFilters() {
  const { t, i18n } = useTranslation();
  const formik = useFormikContext<any>();

  const { modelOptions: makesOptions, apiDataLoading: makesApiDataLoading } = useModelSelectOptions(makesSelectProps([{ label: 'All', value: 'all' }]));

  const { modelOptions, apiDataLoading: modelApiDataLoading } = useModelSelectOptions(modelsSelectProps(formik?.values?.vehicle_make, [{ label: 'All', value: 'all' }]));

  const { modelOptions: variantOptions, apiDataLoading: variantApiDataLoading } = useModelSelectOptions(
    variantsSelectProps(formik?.values?.vehicle_model, [{ label: 'All', value: '' }], i18n.language)
  );

  useEffect(() => {
    formik.setFieldValue('vehicle_model', '');
    formik.setFieldValue('variant', '');
  }, [formik?.values?.vehicle_make]);

  useEffect(() => {
    formik.setFieldValue('variant', '');
  }, [formik?.values?.vehicle_model]);

  useEffect(() => {
    if (makesOptions?.length == 2) {
      formik.setFieldValue('vehicle_make', makesOptions[1]?.value);
    }
  }, [makesOptions]);

  const modelValue = modelOptions?.find((item: any) => item?.value === formik?.values?.vehicle_model);
  const variantValue = variantOptions?.find((item: any) => item?.value === formik?.values?.variant);

  return (
    <Fragment>
      <div className="filter_container">
        {makesOptions?.length <= 2 ? null : makesApiDataLoading ? (
          <FieldWrapper noPadding>
            <InputSkeleton noHeader noMargin />
          </FieldWrapper>
        ) : (
          <FieldWrapper
            customPadding
            inputName={`vehicle_make`}
            inputPlaceholder={t('make')}
            options={makesOptions}
            value={makesOptions?.find((item: any) => item?.value === formik?.values?.vehicle_make)}
            selectStyle={customSelectStyles}
            select
            search
            noPadding
          />
        )}
        {modelApiDataLoading ? (
          <FieldWrapper noPadding>
            <InputSkeleton noHeader noMargin />
          </FieldWrapper>
        ) : (
          <FieldWrapper
            customPadding
            inputName={`vehicle_model`}
            inputPlaceholder={!formik?.values?.vehicle_make ? `${t('model')}, ${t('choose_vehicle_make_first')}` : t('model')}
            options={modelOptions}
            value={!modelValue?.value ? null : modelValue}
            disabled={!formik?.values?.vehicle_make}
            selectStyle={customSelectStyles}
            select
            search
            noPadding
          />
        )}
        {variantApiDataLoading ? (
          <FieldWrapper noPadding>
            <InputSkeleton noHeader noMargin />
          </FieldWrapper>
        ) : (
          <FieldWrapper
            customPadding
            inputName={`variant`}
            inputPlaceholder={!formik?.values?.vehicle_model ? `${t('variant')}, ${t('choose_vehicle_model_first')}` : t('variant')}
            options={variantOptions}
            value={!variantValue?.value ? null : variantValue}
            disabled={!formik?.values?.vehicle_model}
            selectStyle={customSelectStyles}
            select
            search
            noPadding
          />
        )}
        {makesOptions?.length <= 2 ? <FieldWrapper noPadding /> : null}
      </div>
    </Fragment>
  );
}
